export const LISTING_IMPLEMENTATION = 'eb-web';

export const listingsPagePropertiesBootstrap =
  '(function(){var page=Object.assign({},window._EB_TRACKING_PAGE_PROPS,{listingImplementation:"' +
  LISTING_IMPLEMENTATION +
  '"});window._EB_TRACKING_PAGE_PROPS=page;window.dataLayer=window.dataLayer||[];' +
  'window.dataLayer.push({event:"Update Page Props",sendToHeap:true,page:page});})();';

type TrackingWindow = Window & {
  _EB_TRACKING_PAGE_PROPS?: Record<string, unknown>;
  dataLayer?: Record<string, unknown>[];
};

export function setListingsPageImplementation(active: boolean) {
  if (typeof window === 'undefined') return;

  const trackingWindow = window as TrackingWindow;
  if (!active && trackingWindow._EB_TRACKING_PAGE_PROPS?.listingImplementation !== LISTING_IMPLEMENTATION) return;

  const page = {
    ...trackingWindow._EB_TRACKING_PAGE_PROPS,
    listingImplementation: active ? LISTING_IMPLEMENTATION : null,
  };
  trackingWindow._EB_TRACKING_PAGE_PROPS = page;
  trackingWindow.dataLayer ??= [];
  trackingWindow.dataLayer.push({ event: 'Update Page Props', sendToHeap: true, page });
}
